// src/components/EnergyChartCurrentSituation.js
import React, { useState, useEffect } from "react";
import { useFetchEnergyData } from "../fetch-data/FetchCurrentSituationData";
import EnergyTable from "./table/CurrentSituationTable";
import EnergyBarChartCurrentSituation from "./horizontal-bar-chart/EnergyBarChartCurrentSituation";

function EnergyChartCurrentSituation({ location_key }) {
  const { rawData, error } = useFetchEnergyData(location_key);

  const [readyToRender, setReadyToRender] = useState(false);

  useEffect(() => {
    if (rawData) {
      setReadyToRender(true);
    }
  }, [rawData]);

  if (!readyToRender) {
    return <p>Lade Daten...</p>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div className="p-5 m-5 border bg-white shadow-lg rounded-lg">
      <EnergyTable rawData={rawData} />
      <EnergyBarChartCurrentSituation
        rawData={rawData}
      />
    </div>
  );
}

export default EnergyChartCurrentSituation;
